"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InCallBookmarks = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../context/room_session");
const rxjs_1 = require("../../../hooks/rxjs");
const get_protobuf_timestamp_1 = require("../../../util/get_protobuf_timestamp");
const use_bookmark_to_select_1 = require("../../../hooks/use_bookmark_to_select");
const InCallBookmarks = () => {
    const theme = (0, ui_react_1.useTheme)();
    const roomSession = (0, room_session_1.useRoomSession)();
    const [bookmarks] = (0, rxjs_1.useObservable)(roomSession.bookmarks.bookmarks);
    const [callStartTime] = (0, rxjs_1.useObservable)(roomSession.bookmarks.callStartTime);
    const addBookmark = () => {
        roomSession.bookmarks.addBookmark({
            timestamp: (0, get_protobuf_timestamp_1.getProtobufTimestamp)(),
        });
    };
    const updateBookmark = (id, bookmark, label) => {
        roomSession.bookmarks.updateBookmark(id, Object.assign(Object.assign({}, bookmark), { label }));
    };
    const deleteBookmark = (id) => __awaiter(void 0, void 0, void 0, function* () {
        yield roomSession.bookmarks.deleteBookmark(id);
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ justifyContent: "center" }, { children: (0, jsx_runtime_1.jsxs)(ui_react_1.Button, Object.assign({ variant: "tertiary", onClick: addBookmark }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { color: theme.colors.azure, name: "AddBookmarkIcon" }), ' ', (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { marginLeft: '6px', fontSize: '18px' } }, { children: "Add Bookmark" }))] })) })), (0, jsx_runtime_1.jsx)(BookmarkListWrapper, Object.assign({ "data-testid": "bookmark-wrapper" }, { children: bookmarks &&
                    bookmarks.map(bookmark => ((0, jsx_runtime_1.jsx)(Bookmark, { bookmark: bookmark.bookmark, id: bookmark.id, callStartTime: callStartTime === null || callStartTime === void 0 ? void 0 : callStartTime.clientCreatedAt, updateBookmark: updateBookmark, deleteBookmark: () => {
                            deleteBookmark(bookmark.id);
                        } }, bookmark.id))) }))] }));
};
exports.InCallBookmarks = InCallBookmarks;
const Bookmark = ({ bookmark, callStartTime, deleteBookmark, id, updateBookmark, }) => {
    const theme = (0, ui_react_1.useTheme)();
    const [timestampToDisplay, setTimestampToDisplay] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        if (callStartTime) {
            const videoStartTime = callStartTime.seconds.low + callStartTime.nanos / 1000000000;
            const bookmarkTime = bookmark.timestamp.seconds.low + bookmark.timestamp.nanos / 1000000000;
            setTimestampToDisplay(convertTimeStampToReadableString(bookmarkTime - videoStartTime));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callStartTime]);
    const updateBookmarkHandler = (label) => {
        updateBookmark(id, bookmark, label);
    };
    return ((0, jsx_runtime_1.jsxs)(BookmarkItemWrapper, Object.assign({ "data-testid": id }, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { color: theme.colors.black, name: "BookmarkIcon" }) }), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ size: "mediumLarge", style: { marginLeft: theme.spacing.m, marginRight: theme.spacing.m } }, { children: timestampToDisplay })), (0, jsx_runtime_1.jsx)(BookmarkInput, { updateBookmark: updateBookmarkHandler, id: id, bookmark: bookmark }), (0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { label: "Delete Bookmark", "data-testid": "delete-bookmark-button", iconName: "TrashIcon", fill: theme.colors.black, hoverFill: theme.colors.red50, background: "transparent", onClick: deleteBookmark })] }), id));
};
const BookmarkInput = ({ bookmark, id, updateBookmark, }) => {
    const theme = (0, ui_react_1.useTheme)();
    const [label, setLabel] = (0, react_1.useState)((bookmark === null || bookmark === void 0 ? void 0 : bookmark.label) || '');
    const [originalLabel, setOriginalLabel] = (0, react_1.useState)('');
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const inputEl = (0, react_1.useRef)(null);
    const [bookmarkToSelect, clearBookmarkToSelect] = (0, use_bookmark_to_select_1.useBookmarkToSelect)();
    (0, react_1.useEffect)(() => {
        var _a;
        if ((bookmarkToSelect === null || bookmarkToSelect === void 0 ? void 0 : bookmarkToSelect.id) === id) {
            (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.focus();
            clearBookmarkToSelect();
        }
    }, [id, bookmarkToSelect, clearBookmarkToSelect, inputEl]);
    function checkUpdateBookmark() {
        if (label != originalLabel) {
            updateBookmark(label);
        }
    }
    return ((0, jsx_runtime_1.jsx)(BookmarkInputWrapper, { children: (0, jsx_runtime_1.jsx)(ui_react_1.BaseInput, { ref: inputEl, fontSize: 2, "data-testid": `bookmark-label-${id}`, backgroundColor: isFocused ? 'white' : 'transparent', border: isFocused ? '2px solid' : '0px solid', borderColor: theme.colors.azure, borderRadius: '6px', py: 3, px: 3, hideLabel: true, value: label, name: (bookmark === null || bookmark === void 0 ? void 0 : bookmark.label) || '', placeholder: "Untitled Bookmark", onFocus: () => {
                var _a;
                setIsFocused(true);
                setOriginalLabel(label);
                (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.select();
            }, onBlur: () => {
                setIsFocused(false);
                checkUpdateBookmark();
            }, onKeyPress: e => {
                var _a;
                if (e.key === 'Enter') {
                    (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.blur();
                }
            }, onKeyDown: e => {
                if (e.key === 'Escape') {
                    setLabel(originalLabel);
                    // Wait a tick to blur so that label gets updated
                    setTimeout(() => {
                        var _a;
                        (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.blur();
                    }, 10);
                }
            }, onChange: e => {
                setLabel(e.target.value);
            } }) }));
};
const BookmarkListWrapper = ui_react_1.styled.div({
    marginTop: '16px',
});
const BookmarkItemWrapper = ui_react_1.styled.li(({ theme }) => ({
    display: 'flex',
    marginBottom: '12px',
    alignItems: 'center',
    backgroundColor: theme.colors.grey05,
    borderRadius: 4,
    padding: theme.spacing.m,
    height: 60,
}));
const BookmarkInputWrapper = ui_react_1.styled.div(({ theme }) => ({
    ':hover': {
        backgroundColor: theme.colors.pumpedHoverBlue,
    },
    width: '100%',
    borderRadius: '6px',
}));
const convertTimeStampToReadableString = (secondsElapsed) => {
    const minutes = Math.floor(secondsElapsed / 60);
    const seconds = Math.floor(secondsElapsed % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};
//# sourceMappingURL=in_call_bookmarks.js.map